import Loading from "../Loading/Loading";
import cx from "classnames";
import { AvatarSizes } from "./Avatar";
interface IProps {
    size: AvatarSizes;
    color?: boolean;
    backgroundGrey?: boolean;
}
const AvatarLoading: React.FC<IProps> = ({ size, backgroundGrey }) => {
    const getSize = () => {
        switch (size) {
            case 'sm':
                return 40;
            case 'md':
                return 60;
            case 'lg':
            default:
                return 80;
        }
    }
    return (
        <div className={cx("KCL_avatar", size, { grey: backgroundGrey })}>
            <Loading type="circle" width={getSize()} />
        </div>
    );
}

export default AvatarLoading;